import React from "react";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const CartIcon = () => {
  const { cart = [] } = useCart();

  const itemCount = cart.reduce((total, item) => total + (item.quantity || 0), 0);

  return (
    <Link to="/cart" className="relative inline-flex items-center">
      <ShoppingCart className="w-6 h-6" />
      {itemCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </Link>
  );
};

export default CartIcon;
